export const CategoryData = [
	{
		name: "Masonry",
		value: "Masonry",
	},
	{
		name: "Electrical",
		value: "Electrical",
	},
	{
		name: "Steel",
		value: "Steel",
	},
	{
		name: "Roofing",
		value: "Roofing",
	},
	{
		name: "Concreting",
		value: "Concreting",
	},
	{
		name: "Flooring",
		value: "Flooring",
	},
	{
		name: "Framing",
		value: "Framing",
	},
];

export const SubCategoryData = [
	{
		name: "New Stocks",
		value: "New Stocks",
	},
	{
		name: "Discounted Items",
		value: "Discounted Items",
	},
	{
		name: "Flash Deals",
		value: "Flash Deals",
	},
];

export const InteriorDesign = [
	{
		name: "Bedroom",
		value: "Bedroom",
	},
	{
		name: "Toilet/bath 1st floor",
		value: "Toilet/bath 1st floor",
	},
	{
		name: "Toilet/bath 2nd floor",
		value: "Toilet/bath 2nd floor",
	},
	{
		name: "Kitchen",
		value: "Kitchen",
	},
	{
		name: "Living Area",
		value: "Living Area",
	},
	{
		name: "Dining Area",
		value: "Dining Area",
	},
];
